/* eslint-disable */
class Post {
	title;

	description;

	alias;

	featured;

	imageLink;

	link;

	created;

	published;

	category;

	template;

	element;

	render(postIndex) {
		if (this.element) return this.element;
		this.element = this.template.getElement(this, postIndex);
		return this.element;
	}
}

export { Post };
